function India({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1372)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M16 0C9.65664 0 4.17565 3.69156 1.58765 9.0435H30.4123C27.8244 3.69156 22.3433 0 16 0Z" fill="#FF9811"/>
  <path d="M16 32C22.3433 32 27.8244 28.3085 30.4124 22.9565H1.58765C4.17565 28.3085 9.65664 32 16 32Z" fill="#6DA544"/>
  <path d="M16 21.5649C19.0736 21.5649 21.5652 19.0733 21.5652 15.9998C21.5652 12.9262 19.0736 10.4346 16 10.4346C12.9264 10.4346 10.4348 12.9262 10.4348 15.9998C10.4348 19.0733 12.9264 21.5649 16 21.5649Z" fill="#0052B4"/>
  <path d="M16 19.4785C17.921 19.4785 19.4782 17.9212 19.4782 16.0002C19.4782 14.0792 17.921 12.522 16 12.522C14.079 12.522 12.5217 14.0792 12.5217 16.0002C12.5217 17.9212 14.079 19.4785 16 19.4785Z" fill="#F0F0F0"/>
  <path d="M16 11.708L17.0731 14.1416L19.7171 13.8541L18.1461 16.0001L19.7171 18.1462L17.0731 17.8586L16 20.2923L14.927 17.8586L12.283 18.1461L13.854 16.0001L12.283 13.8541L14.927 14.1416L16 11.708Z" fill="#0052B4"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default India;
